import { MessageContext } from '../providers/MessageProvider';

// Error handler for scheduling API calls
export async function handleSchedulingApiError(response, showMessage, onError = null) {
    if (!response.ok) {
        try {
            const errorData = await response.json();
            
            // Handle 403 Forbidden (permission denied)
            if (response.status === 403) {
                if (errorData.error === 'INSUFFICIENT_PERMISSIONS') {
                    showMessage({
                        title: 'Access Denied',
                        message: errorData.message || 'You don\'t have permission to perform this action.',
                        isOkCancel: false
                    });
                    if (onError) onError();
                    return true; // Indicates error was handled
                } else if (errorData.error === 'NO_ROLES_ASSIGNED') {
                    showMessage({
                        title: 'No Access',
                        message: errorData.message || 'Unable to confirm account access. Please try logging out and in again. If you\'re still seeing this message, please email devs@citysidefiber.com',
                        isOkCancel: false
                    });
                    if (onError) onError();
                    return true;
                }
            }
            
            // Handle 401 Unauthorized (session expired)
            if (response.status === 401) {
                if (errorData.requiresAuth) {
                    showMessage({
                        title: 'Session Expired',
                        message: errorData.message || 'Your login has been revalidated. Please try again, and contact devs@citysidefiber.com if this message persists.',
                        isOkCancel: false
                    });
                    setTimeout(() => {
                        window.location.href = errorData.redirect || 'https://crm.citysidefiber.com/auth/login';
                    }, 2000);
                    return true;
                } else {
                    showMessage({
                        title: 'Login Revalidated',
                        message: 'Your login has been revalidated. Please try again, and contact devs@citysidefiber.com if this message persists.',
                        isOkCancel: false
                    });
                    setTimeout(() => {
                        window.location.href = 'https://crm.citysidefiber.com/auth/login';
                    }, 2000);
                    return true;
                }
            }
            
            // Handle other errors
            showMessage({
                title: 'Error',
                message: errorData.message || 'An error occurred while processing your request.',
                isOkCancel: false
            });
            if (onError) onError();
            return true;
            
        } catch (parseError) {
            // If we can't parse the error response, show a generic error
            showMessage({
                title: 'Error',
                message: 'An unexpected error occurred. Please try again.',
                isOkCancel: false
            });
            if (onError) onError();
            return true;
        }
    }
    
    return false; // No error occurred
}

// Wrapper function for scheduling API calls
export async function makeSchedulingApiCall(url, options = {}, showMessage) {
    try {
        const response = await fetch(url, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            },
            ...options
        });

        // Check for errors and handle them
        const errorHandled = await handleSchedulingApiError(response, showMessage);
        if (errorHandled) {
            return null; // Return null to indicate error was handled
        }

        // If response is ok, return the parsed JSON
        return await response.json();
        
    } catch (error) {
        console.error('Error in scheduling API call:', error);
        showMessage({
            title: 'Error',
            message: error.message || 'Failed to process your request. Please try again.',
            isOkCancel: false
        });
        return null;
    }
}
